export default __webpack_public_path__ + "static/media/logo_arbitrum_one.b4748835.svg";